module.exports = __webpack_public_path__ + "static/media/image_preview.93186674.svg";